import { REFUND_WALLET_STATE } from './constants'

export const getStatus = state => state[REFUND_WALLET_STATE].status
